import Navbar from '@/components/feature/Navbar';
import ContactFooter from '@/pages/home/components/ContactFooter';

const sections = [
  {
    title: '제1조 (개인정보의 처리 목적)',
    content: `코리아케어러스(이하 "회사")는 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고 있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며, 이용 목적이 변경되는 경우에는 개인정보 보호법 제18조에 따라 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다.

1. 가족간병 등록 및 서비스 신청: 가족간병 서비스 신청, 간병인 매칭, 서비스 이용 현황 파악 등의 목적으로 개인정보를 처리합니다.
2. 보험 청구 지원 서비스: 간병보험 청구 관련 서류 제출 대행, 보험사 연계 업무 처리 목적으로 개인정보를 처리합니다.
3. 고객 상담 및 불만 처리: 민원인의 신원 확인, 민원 사항 확인, 사실 조사를 위한 연락·통지, 처리 결과 통보 목적으로 개인정보를 처리합니다.
4. 마케팅 및 광고 활용: 신규 서비스 개발 및 맞춤 서비스 제공, 이벤트 및 광고성 정보 제공 및 참여 기회 제공 등의 목적으로 개인정보를 처리합니다.`,
  },
  {
    title: '제2조 (개인정보의 처리 및 보유기간)',
    content: `① 회사는 법령에 따른 개인정보 보유·이용 기간 또는 정보주체로부터 개인정보를 수집 시에 동의 받은 개인정보 보유·이용 기간 내에서 개인정보를 처리·보유합니다.

② 각각의 개인정보 처리 및 보유 기간은 다음과 같습니다.

1. 가족간병 등록 및 서비스 신청: 서비스 종료 후 3년
   - 보존 근거: 전자상거래 등에서의 소비자 보호에 관한 법률
2. 고객 상담 및 불만 처리: 3년
   - 보존 근거: 전자상거래 등에서의 소비자 보호에 관한 법률
3. 보험 청구 지원 서비스 관련 서류: 5년
   - 보존 근거: 상법, 보험업법`,
  },
  {
    title: '제3조 (처리하는 개인정보의 항목)',
    content: `① 회사는 다음의 개인정보 항목을 처리하고 있습니다.

1. 가족간병 등록 서비스
   - 필수항목: 성명, 생년월일, 성별, 연락처(휴대폰 번호), 주소, 입원 병원명, 병실 정보
   - 선택항목: 이메일 주소, 보험 가입 정보

2. 간병인 등록
   - 필수항목: 성명, 생년월일, 성별, 연락처(휴대폰 번호), 주소, 신분증 정보(앞면)
   - 선택항목: 경력 사항, 자격증 정보

3. 보험 청구 지원
   - 필수항목: 성명, 연락처, 입·퇴원 확인서, 간병일지, 간병비 이체 영수증
   - 선택항목: 초진 차트, 진료비 세부내역서

4. 고객 상담
   - 필수항목: 성명, 연락처
   - 선택항목: 이메일 주소, 상담 내용`,
  },
  {
    title: '제4조 (개인정보의 제3자 제공)',
    content: `① 회사는 정보주체의 개인정보를 제1조(개인정보의 처리 목적)에서 명시한 범위 내에서만 처리하며, 정보주체의 동의, 법률의 특별한 규정 등 개인정보 보호법 제17조에 해당하는 경우에만 개인정보를 제3자에게 제공합니다.

② 회사는 보험 청구 지원 서비스 제공을 위해 다음과 같이 개인정보를 제3자에게 제공하고 있습니다.

- 제공받는 자: 보험사 (계약 체결된 보험사에 한함)
- 제공 목적: 간병보험 청구 처리
- 제공 항목: 성명, 입·퇴원 확인서, 간병일지, 간병비 이체 영수증
- 보유 및 이용 기간: 보험 청구 완료 후 즉시 삭제 (법령상 보존 의무 기간 제외)`,
  },
  {
    title: '제5조 (개인정보처리의 위탁)',
    content: `① 회사는 원활한 개인정보 업무처리를 위하여 다음과 같이 개인정보 처리업무를 위탁하고 있습니다.

- 위탁받는 자: 카카오 주식회사
- 위탁하는 업무의 내용: 카카오톡 비즈니스 채널 상담 서비스 운영

- 위탁받는 자: Amazon Web Services
- 위탁하는 업무의 내용: 클라우드 서버 운영 및 데이터 보관

② 회사는 위탁계약 체결 시 개인정보 보호법 제26조에 따라 위탁업무 수행 목적 외 개인정보 처리 금지, 기술적·관리적 보호조치, 재위탁 제한, 수탁자에 대한 관리·감독, 손해배상 등 책임에 관한 사항을 계약서 등 문서에 명시하고, 수탁자가 개인정보를 안전하게 처리하는지를 감독하고 있습니다.`,
  },
  {
    title: '제6조 (정보주체의 권리·의무 및 행사방법)',
    content: `① 정보주체는 회사에 대해 언제든지 다음 각 호의 개인정보 보호 관련 권리를 행사할 수 있습니다.

1. 개인정보 열람 요구
2. 오류 등이 있을 경우 정정 요구
3. 삭제 요구
4. 처리 정지 요구

② 제1항에 따른 권리 행사는 회사에 대해 서면, 전화, 전자우편, 모사전송(FAX) 등을 통하여 하실 수 있으며, 회사는 이에 대해 지체없이 조치하겠습니다.

③ 정보주체가 개인정보의 오류 등에 대한 정정 또는 삭제를 요구한 경우에는 회사는 정정 또는 삭제를 완료할 때까지 당해 개인정보를 이용하거나 제공하지 않습니다.

④ 제1항에 따른 권리 행사는 정보주체의 법정대리인이나 위임을 받은 자 등 대리인을 통하여 하실 수 있습니다. 이 경우 개인정보 보호법 시행규칙 별지 제11호 서식에 따른 위임장을 제출하셔야 합니다.`,
  },
  {
    title: '제7조 (개인정보의 파기)',
    content: `① 회사는 개인정보 보유기간의 경과, 처리목적 달성 등 개인정보가 불필요하게 되었을 때에는 지체없이 해당 개인정보를 파기합니다.

② 정보주체로부터 동의받은 개인정보 보유기간이 경과하거나 처리목적이 달성되었음에도 불구하고 다른 법령에 따라 개인정보를 계속 보존하여야 하는 경우에는, 해당 개인정보를 별도의 데이터베이스(DB)로 옮기거나 보관 장소를 달리하여 보존합니다.

③ 개인정보 파기의 절차 및 방법은 다음과 같습니다.
1. 파기 절차: 회사는 파기 사유가 발생한 개인정보를 선정하고, 회사의 개인정보 보호책임자의 승인을 받아 개인정보를 파기합니다.
2. 파기 방법: 전자적 파일 형태의 정보는 기록을 재생할 수 없는 기술적 방법을 사용합니다. 종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을 통하여 파기합니다.`,
  },
  {
    title: '제8조 (개인정보의 안전성 확보조치)',
    content: `회사는 개인정보의 안전성 확보를 위해 다음과 같은 조치를 취하고 있습니다.

1. 관리적 조치: 내부관리계획 수립·시행, 정기적 직원 교육 등
2. 기술적 조치: 개인정보처리시스템 등의 접근 권한 관리, 접근통제시스템 설치, 고유식별정보 등의 암호화, 보안 프로그램 설치
3. 물리적 조치: 전산실, 자료보관실 등의 접근 통제`,
  },
  {
    title: '제9조 (개인정보 보호책임자)',
    content: `① 회사는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의 불만 처리 및 피해구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.

▶ 개인정보 보호책임자
- 성명: 박종영
- 직책: 대표
- 연락처: 1566-8654, support@koreacarers.com
- FAX: 070-7862-8654

② 정보주체께서는 회사의 서비스를 이용하시면서 발생한 모든 개인정보 보호 관련 문의, 불만 처리, 피해구제 등에 관한 사항을 개인정보 보호책임자에게 문의하실 수 있습니다. 회사는 정보주체의 문의에 대해 지체없이 답변 및 처리해드릴 것입니다.`,
  },
  {
    title: '제10조 (개인정보 처리방침 변경)',
    content: `① 이 개인정보 처리방침은 2026년 1월 1일부터 적용됩니다.

② 이전의 개인정보 처리방침은 아래에서 확인하실 수 있습니다.
- 해당 없음

③ 개인정보 처리방침이 변경될 경우 변경 사항을 시행일 7일 전부터 홈페이지 공지사항을 통해 사전 공지할 예정입니다.`,
  },
];

export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero */}
      <section className="w-full pt-32 pb-16" style={{ backgroundColor: '#f4faf8' }}>
        <div className="max-w-4xl mx-auto px-6 text-center">
          <p className="text-xs font-semibold tracking-widest uppercase mb-3" style={{ color: '#2E7D6B' }}>LEGAL</p>
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">개인정보처리방침</h1>
          <p className="text-sm text-gray-500">시행일: 2026년 1월 1일</p>
          <p className="text-sm text-gray-500 mt-2 max-w-2xl mx-auto leading-relaxed">
            코리아케어러스는 고객의 개인정보를 소중히 여기며, 개인정보 보호법을 준수합니다.
            본 방침은 회사가 수집하는 개인정보의 처리 목적, 보유 기간, 파기 방법 등을 안내합니다.
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="w-full py-16">
        <div className="max-w-4xl mx-auto px-6">
          <div className="space-y-10">
            {sections.map((section, index) => (
              <div key={index} className="border-b border-gray-100 pb-10 last:border-0">
                <h2 className="text-base font-bold text-gray-900 mb-4 flex items-start gap-3">
                  <span className="flex-shrink-0 w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold text-white" style={{ backgroundColor: '#2E7D6B' }}>
                    {index + 1}
                  </span>
                  {section.title}
                </h2>
                <div className="pl-9">
                  <p className="text-sm text-gray-600 leading-relaxed whitespace-pre-line">{section.content}</p>
                </div>
              </div>
            ))}
          </div>

          {/* Contact box */}
          <div className="mt-12 p-6 rounded-2xl" style={{ backgroundColor: '#f4faf8' }}>
            <p className="text-sm font-semibold text-gray-800 mb-2">개인정보 관련 문의</p>
            <p className="text-xs text-gray-500 leading-relaxed">
              개인정보 처리에 관한 문의사항은 아래로 연락해 주세요.<br />
              전화: 1566-8654 | 이메일: support@koreacarers.com | FAX: 070-7862-8654
            </p>
          </div>
        </div>
      </section>

      <ContactFooter />
    </div>
  );
}
